/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Toast_Failed_DescriptionInputs */

const en_auth_login_toast_failed_description = /** @type {(inputs: Auth_Login_Toast_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong signing you in. Please try again.`)
};

const pl_auth_login_toast_failed_description = /** @type {(inputs: Auth_Login_Toast_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak podczas logowania. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Something went wrong signing you in. Please try again." |
*
* @param {Auth_Login_Toast_Failed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_toast_failed_description = /** @type {((inputs?: Auth_Login_Toast_Failed_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Toast_Failed_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_toast_failed_description(inputs)
	return en_auth_login_toast_failed_description(inputs)
});